import { styled } from '@zenbusiness/zui/styles';

import TextareaAutosize from '@mui/material/TextareaAutosize';

const WireTextareaStyle = ({ theme, isValid }) => ({
  padding: '20px 16px',
  borderRadius: '16px',
  fontFamily: 'inherit',
  fontSize: '16px',
  border: `1px solid ${!isValid ? theme.palette.error.main : theme.palette.fixed.black}`,
  resize: 'none',
  outline: 'none',
  '&:focus': {
    borderColor: !isValid ? theme.palette.error.main : theme.palette.fixed.black
  },
  '::placeholder': {
    color: !isValid ? theme.palette.text.red : theme.palette.text.secondary
  },
  [theme.breakpoints.up('md')]: {
    fontSize: '20px'
  }
});

const TransactionDescContainerStyle = ({ theme }) => ({
  backgroundColor: theme.palette.background.grey.main,
  padding: '16px 24px',
  borderRadius: '16px',
  border: `1px solid ${theme.palette.border.main}`
});

export const FieldContainerStyled = styled('div')(TransactionDescContainerStyle);
export const TextareaStyled = styled(TextareaAutosize, {
  shouldForwardProp: (prop) => prop !== 'isValid'
})(WireTextareaStyle);
